import React, { PureComponent } from 'react'
import './index.css'

class Text extends PureComponent {
  render() {
    return (
      <textarea { ...this.props } />
    )
  }
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Text/index.js